import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ScreenType } from 'src/app/enums/ScreenType';
import { ICalendarState } from 'src/app/state-management/states/aumye-calendar.state';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import { getFullDate } from 'src/app/utils/date-util';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
})
export class TimePickerComponent implements AfterViewInit {
  displayedColumns: string[] = ['no', 'time', 'select'];
  @Input() calDimensions: any;
  @Input() selectedDate: any;
  @Output() selectedDateTimeSlot = new EventEmitter();

  @Input() set screen(val: ScreenType) {
    this.screenInfo = val;
  }

  todayDate: Date;
  screenInfo: ScreenType;
  error: any;
  isLoading = true;
  style: any;
  destroyed$: Subject<any> = new Subject<any>();
  calendarState$: Observable<ICalendarState>;
  timeSLOTS: any = [];
  dataSource: any;
  filteredDataSource: any;
  styleTable: { height: string };
  constructor(private store: Store<IAumyeState>, private datePipe: DatePipe) {
    this.calendarState$ = this.store.select('aumyeCalendarState');
    this.calendarState$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.timeSLOTS = data.timeSlots.list;
      this.error = data.timeSlots.Error;
      this.isLoading = data.flows.isFetchingTimeSlots;
      this.dataSource = this.timeSLOTS;
      const result: any[] = [];
      this.timeSLOTS.forEach((temp: any) => {
        let time = new Date(temp.time);
        if (time.getTime() > new Date().getTime()) {
          result.push(temp);
        }
      });
      this.filteredDataSource = result;
    });
    this.todayDate = new Date();
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getDivStyle();
    });
  }

  getDivStyle() {
    if (this.calDimensions) {
      this.style = {
        height: this.calDimensions.height.valueOf() + 'px',
        width: this.calDimensions.width.valueOf() + 'px',
      };
      this.styleTable = {
        height: (this.calDimensions.height - 50).toString() + 'px', //48 is header Height
      };
    }
  }
  radioChange(val: any) {
    let temp = val.time;
    let ntemp = this.datePipe.transform(val.time, 'mm/dd/yyyy');
    // let newtemp = temp.toISOString();
    let temoselecteddate = new Date(
      this.selectedDate.setHours(this.selectedDate.getHours() + 5)
    );
    temoselecteddate = new Date(
      temoselecteddate.setMinutes(temoselecteddate.getMinutes() + 30)
    );

    let value = getFullDate(temp, temoselecteddate.toISOString());
    this.selectedDateTimeSlot.emit(new Date(value));
  }
  ScreenType = ScreenType;
}
